export { default as english } from "./english";
export { default as spanish } from "./spanish";



// WEBPACK FOOTER //
// ./src/constants/strings/index.js